<div id="mauticform_wrapper_socialempresa2" class="mauticform_wrapper">
    <form #form2 autocomplete="false" role="form" method="post" action="{{formApiUrl}}?formId=23"
        id="mauticform_socialempresa2" data-mautic-form="socialempresa2" enctype="multipart/form-data">
        <div class="mauticform-error" id="mauticform_socialempresa2_error"></div>
        <div class="mauticform-message" id="mauticform_socialempresa2_message"></div>
        <div class="mauticform-innerform">


            <div class="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">

                <div id="mauticform_socialempresa2_email" data-validate="email" data-validation-type="email"
                    class="mauticform-row mauticform-email mauticform-field-1 mauticform-required">

                    <input id="mauticform_input_socialempresa2_email" name="mauticform[email]" [value]="formData.email"
                        class="mauticform-input" type="email">

                </div>

                <div id="mauticform_socialempresa2_instagram" class="mauticform-row mauticform-text mauticform-field-2">

                    <input id="mauticform_input_socialempresa2_instagram" name="mauticform[instagram]"
                        [value]="formData.instagram" class="mauticform-input" type="text">

                </div>

                <div id="mauticform_socialempresa2_facebook" class="mauticform-row mauticform-text mauticform-field-3">

                    <input id="mauticform_input_socialempresa2_facebook" name="mauticform[facebook]"
                        [value]="formData.facebook" class="mauticform-input" type="text">

                </div>

                <div id="mauticform_socialempresa2_youtube" class="mauticform-row mauticform-text mauticform-field-4">

                    <input id="mauticform_input_socialempresa2_youtube" name="mauticform[youtube]"
                        [value]="formData.youtube" class="mauticform-input" type="text">

                </div>

                <div id="mauticform_socialempresa2_submit"
                    class="mauticform-row mauticform-button-wrapper mauticform-field-5">
                    <button type="submit" name="mauticform[submit]" id="mauticform_input_socialempresa2_submit" value=""
                        class="mauticform-button btn btn-default">Enviar</button>
                </div>
            </div>
        </div>

        <input type="hidden" name="mauticform[formId]" id="mauticform_socialempresa2_id" value="23">
        <input type="hidden" name="mauticform[return]" id="mauticform_socialempresa2_return" value="">
        <input type="hidden" name="mauticform[formName]" id="mauticform_socialempresa2_name" value="socialempresa2">

    </form>
</div>